import script from "./ai-detail-analysis.vue?vue&type=script&setup=true&lang=js"
export * from "./ai-detail-analysis.vue?vue&type=script&setup=true&lang=js"

import "./ai-detail-analysis.vue?vue&type=style&index=0&id=37771660&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37771660"]])

export default __exports__